
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/dpa",
      function () {
        return require("private-next-pages/privacy/dpa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/dpa"])
      });
    }
  